import React from 'react'

const GalleryContext = React.createContext({})

export default GalleryContext
